import { client } from './client';
import type { DashboardResponse } from '../types/dashboard';

export const dashboardApi = {
  get: () =>
    client.get<DashboardResponse>('/api/v1/dashboard'),
};
